import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import Base from '../abstracts/Base/index.js';
import damp from '../utils/math/damp.js';
import matrix from '../utils/css/matrix.js';

var Cursor = function (_Base) {
  _inherits(Cursor, _Base);

  var _super = _createSuper(Cursor);

  function Cursor() {
    var _this;

    _classCallCheck(this, Cursor);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "x", 0);

    _defineProperty(_assertThisInitialized(_this), "y", 0);

    _defineProperty(_assertThisInitialized(_this), "scale", 0);

    _defineProperty(_assertThisInitialized(_this), "pointerX", 0);

    _defineProperty(_assertThisInitialized(_this), "pointerY", 0);

    _defineProperty(_assertThisInitialized(_this), "pointerScale", 0);

    return _this;
  }

  _createClass(Cursor, [{
    key: "mounted",
    value: function mounted() {
      this.x = 0;
      this.y = 0;
      this.scale = 0;
      this.pointerX = 0;
      this.pointerY = 0;
      this.pointerScale = 0;
      this.render({
        x: this.x,
        y: this.y,
        scale: this.scale
      });
    }
  }, {
    key: "moved",
    value: function moved(_ref) {
      var event = _ref.event,
          x = _ref.x,
          y = _ref.y,
          isDown = _ref.isDown;

      if (!this.$services.has('ticked')) {
        this.$services.enable('ticked');
      }

      this.pointerX = x;
      this.pointerY = y;
      var scale = 1;

      if (!event) {
        this.pointerScale = scale;
        return;
      }

      var shouldGrow = event.target instanceof Element && event.target.matches(this.$options.growSelectors) || false;
      var shouldReduce = isDown || event.target instanceof Element && event.target.matches(this.$options.shrinkSelectors) || false;

      if (shouldGrow) {
        scale = this.$options.growTo;
      }

      if (shouldReduce) {
        scale = this.$options.shrinkTo;
      }

      this.pointerScale = scale;
    }
  }, {
    key: "ticked",
    value: function ticked() {
      this.x = damp(this.pointerX, this.x, this.$options.translateDampFactor);
      this.y = damp(this.pointerY, this.y, this.$options.translateDampFactor);
      this.scale = damp(this.pointerScale, this.scale, this.pointerScale < this.scale ? this.$options.shrinkDampFactor : this.$options.growDampFactor);
      this.render({
        x: this.x,
        y: this.y,
        scale: this.scale
      });

      if (this.x === this.pointerX && this.y === this.pointerY && this.scale === this.pointerScale) {
        this.$services.disable('ticked');
      }
    }
  }, {
    key: "render",
    value: function render(_ref2) {
      var x = _ref2.x,
          y = _ref2.y,
          scale = _ref2.scale;
      var transform = matrix({
        translateX: x,
        translateY: y,
        scaleX: scale,
        scaleY: scale
      });
      this.$el.style.transform = "translateZ(0) ".concat(transform);
    }
  }]);

  return Cursor;
}(Base);

_defineProperty(Cursor, "config", {
  name: 'Cursor',
  options: {
    growSelectors: {
      type: String,
      default: 'a, a *, button, button *, [data-cursor-grow], [data-cursor-grow] *'
    },
    shrinkSelectors: {
      type: String,
      default: '[data-cursor-shrink], [data-cursor-shrink] *'
    },
    growTo: {
      type: Number,
      default: 2
    },
    shrinkTo: {
      type: Number,
      default: 0.5
    },
    translateDampFactor: {
      type: Number,
      default: 0.25
    },
    growDampFactor: {
      type: Number,
      default: 0.25
    },
    shrinkDampFactor: {
      type: Number,
      default: 0.25
    }
  }
});

export { Cursor as default };
//# sourceMappingURL=Cursor.js.map